export default {"src":"/_next/static/media/walmart-spark.274c85a1.svg","height":37,"width":33,"blurWidth":0,"blurHeight":0};